<div class="language-dropdown">
  <app-dropdown
    [ariaLabel]="'Select a language'"
    [className]="'select-input language-select'"
    [height]="'50px'"
    [id]="'language-select'"
    [label]="'Language'"
    [name]="'language-select'"
    [options]="languageOptions"
    [value]="locale"
    [width]="'146px'"
    (emitChange)="handleLanguageChange($event)">
  </app-dropdown>
</div>
